import { useMemo } from 'react';
import Button from 'components/commercetools-ui/atoms/button';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import { Reference } from 'types/reference';
import Image, { ImageProps } from 'frontastic/lib/image';
import Slider from 'components/commercetools-ui/atoms/slider';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import useTouchDevice from 'helpers/hooks/useTouchDevice';
import { desktop, mediumDesktop, tablet } from 'helpers/utils/screensizes';
import { StaticImageData } from 'next/image';

export interface ImageSliderProps {
  data: any;
}
type slideType = {
  additional_css: any;
  image: { url: string | StaticImageData | undefined; title: string | undefined ; description: string | undefined };
  call_to_action: { href: string | Reference | undefined };
};


const ImageOnlySlider: React.FC<ImageSliderProps> = ({ data }) => {
  const { isTouchDevice } = useTouchDevice();

  const cmsCssClass = data?.additional_css;

  const [isDesktopSize] = useMediaQuery(mediumDesktop);
  const [isTabletSize] = useMediaQuery(tablet);
  const showArrows = useMemo(
    () =>
      !isTouchDevice && !((isDesktopSize && data?.cards?.length <= 4) || (!isDesktopSize && data?.cards?.length <= 2)),
    [isDesktopSize, isTouchDevice, data?.cards?.length],
  );

  return (
    <div className={`${cmsCssClass} image-only-slider hidden lg:block hero-slider-container w-full`}>
      <Slider
        slidesPerView={isTabletSize ? 1.3 : 1}
        dots={true}
        spaceBetween={16}
        arrows={isTabletSize}
        innerArrows
        allowArrowsOnTouchDevice
        allowTouchMove={true}
        prevButtonStyles={{  padding: '15px', left: '0px' }}
        nextButtonStyles={{  padding: '15px', right: '0px' }}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
      >
        {data?.cards?.map((slide: slideType,index:number) => (
          <div className={`${slide?.additional_css} relative h-[18rem] md:h-[34rem] 2xl:h-[44rem]`} key={index}>
              {slide?.image?.url ? (                
                  <Image
                    loading='lazy'
                    src={slide?.image?.url}
                    alt={slide?.image?.description}
                    fill
                    style={{ objectFit: 'cover' }}
                  />
              ) : (
                <div className="flex-1"></div>
              )}
            </div>
        ))}
      </Slider>
    </div>
  );
};

export default ImageOnlySlider;